module.exports = __webpack_public_path__ + "img/icon-dinero.f24c23fb.png";